import gql from 'graphql-tag'

import { TourOpeningFieldsFragment } from 'main/gql/tour'

export const SCHOOL_PAGE_SCHEDULE_TOUR_BUTTON_QUERY = gql`
  query SchoolPageScheduleTourButtonQuery(
    $schoolId: ID!
    $schoolIdInt: Int!
    $beginsOn: Date!
    $endsOn: Date!
  ) {
    tourOpenings(schoolId: $schoolId, beginsOn: $beginsOn, endsOn: $endsOn, onlySchedulable: true) {
      ...TourOpeningFields
    }
    user {
      id
    }
    tourRequests(schoolId: $schoolIdInt) {
      id
    }
  }

  ${TourOpeningFieldsFragment}
`
